import React from 'react';
import { connect } from 'react-redux';
import { createGroup, resetGroupForm } from '../../../../actions/group';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { hideModal } from '../../../../actions/modal';

@connect()
export default class RightPanelCreate extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      groupForm: props.groupForm,
    };
  }
  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({ groupForm: props.groupForm });
  };

  createGroup = () => {
    let areThereErrors = forceValidation(undefined, undefined, 'createGroupForm');
    if (!areThereErrors) {
      if (this.state.groupForm.name == 'error') {
        this.props.dispatch(displayGlobalMessage({ visible: true }));
      } else {
        let cb = () => {
          this.props.dispatch(hideModal('.insert-group.modal'));
          setTimeout(() => {
            this.resetForm();
          }, 200); //timeout waiting for the hide effect to finish
        };
        this.props.dispatch(createGroup(this.state.groupForm, cb));
      }
    }
  };

  componentWillUnmount = () => {};

  cancelCreateGroup = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());
    this.props.dispatch(hideModal('.insert-group.modal'));

    setTimeout(() => {
      this.resetForm();
    }, 200); //timeout waiting for the hide effect to finish
  };

  componentDidMount = () => {
    this.resetForm();
  };

  resetForm = () => {
    this.props.dispatch(resetGroupForm());
  };

  render() {
    let saveClasses =
      'ui disable labeled icon button icon color-button color-button-hover color-white max-width left-text mrlnull mrbnull';

    return (
      <div className="ui actions mrbl">
        <button
          type="button"
          tabIndex="10"
          onClick={this.createGroup}
          data-group="createGroupForm"
          className={this.state.groupForm && this.state.groupForm.saving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Create}
          <i className="add  icon" />
        </button>
        <button
          type="button"
          tabIndex="11"
          onClick={this.cancelCreateGroup}
          className="ui   labeled icon button color-bad-things color-bad-things-hover color-white    mrtm max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}
